import axios from 'axios';
import * as qs from 'qs';
import { message } from 'antd';
import { ICrudGetAction, ICrudPutAction } from 'react-jhipster';
import { cleanEntity } from 'app/shared/util/entity-utils';
import { FAILURE, REQUEST, SUCCESS } from 'app/shared/reducers/action-type.util';
import { defaultValue, ITableType } from 'app/shared/model/commission-reportment.model';
import { ICrudGetListAction } from 'app/shared/model/list';
import { flattenKey } from 'app/shared/util/object-utils';
// 请求
export const ACTION_TYPES = {
  FETCH_REPORTMENT_LIST: 'reportment/FETCH_REPORTMENT_LIST', // 列表
  FETCH_REPORTMENT: 'reportment/FETCH_REPORTMENT', // 详情
  UPDATE_REPORTMENT: 'reportment/UPDATE_REPORTMENT', // 更新
  RESET: 'reportment/RESET' // 重置
};
// state
const initialState = {
  loading: false,
  fetching: false,
  loadMore: false,
  errorMessage: null,
  entities: [] as ReadonlyArray<ITableType>,
  entity: defaultValue,
  updating: false,
  totalItems: 0,
  updateSuccess: false
};

export type reportmentState = Readonly<typeof initialState>;

// Reducer
export default (state: reportmentState = initialState, action): reportmentState => {
  switch (action.type) {
    case REQUEST(ACTION_TYPES.FETCH_REPORTMENT):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        updating: true
      };
    case REQUEST(ACTION_TYPES.FETCH_REPORTMENT_LIST):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        loading: true,
        fetching: true
      };
    case FAILURE(ACTION_TYPES.FETCH_REPORTMENT):
    case FAILURE(ACTION_TYPES.FETCH_REPORTMENT_LIST):
      return {
        ...state,
        loading: false,
        fetching: false,
        loadMore: false,
        updating: false,
        updateSuccess: false,
        errorMessage: action.payload
      };
    case SUCCESS(ACTION_TYPES.FETCH_REPORTMENT):
      const { data } = action.payload;
      let { industry, source, satisfaction } = data;

      const otherChange = (value, name) => {
        const arr = value.split(':');
        data[`${name}_other`] = arr[1];
        return arr[0];
      };

      industry = industry && industry.indexOf('其他') > -1 ? otherChange(industry, 'reason') : industry;
      source = source && source.indexOf('其他') > -1 ? otherChange(source, 'source') : source;

      if (satisfaction && satisfaction.indexOf('其他') > -1) {
        const arr = satisfaction.split(',');
        const num = arr.findIndex(item => item.indexOf('其他') > -1);
        arr[num] = otherChange(arr[num], 'satisfaction');
        satisfaction = arr;
      }

      return {
        ...state,
        loading: false,
        entity: { ...data, satisfaction, industry, source }
      };
    case SUCCESS(ACTION_TYPES.FETCH_REPORTMENT_LIST):
      return {
        ...state,
        loading: false,
        fetching: false,
        entities: action.payload.data.content || [],
        totalItems: parseInt(action.payload.data['totalElements'], 10)
      };
    case ACTION_TYPES.RESET:
      return {
        ...initialState
      };
    default:
      return state;
  }
};

const apiUrl = '/fy/reporting'; // 看房调查
// Actions
// 看房调查，列表
export const getEntities: ICrudGetListAction<ITableType> = (page, size, sort = '', searchForm) => {
  const requestUrl = `${apiUrl}/list?page=${page}&size=${size}`;
  return {
    type: ACTION_TYPES.FETCH_REPORTMENT_LIST,
    payload: axios.get<ITableType>(`${requestUrl}`, {
      params: flattenKey(searchForm),
      paramsSerializer: params => qs.stringify(params)
    }),
    meta: { transformUserName: true }
  };
};
// 获取看房调查数据
export const getEntity: ICrudGetAction<ITableType> = id => {
  const requestUrl = `${apiUrl}/${id}`;
  return {
    type: ACTION_TYPES.FETCH_REPORTMENT,
    payload: axios.get<ITableType>(requestUrl)
  };
};
export const reset = () => ({
  type: ACTION_TYPES.RESET
});
// 确认到访
export function updateInfo(id) {
  return new Promise((resolve, reject) => {
    axios
      .put(`${apiUrl}/${id}/visit`, cleanEntity(id))
      .then(response => {
        resolve(response.data);
      })
      .catch(errs => {
        // 提取错误信息并显示
        const errorMsg = errs.response && errs.response.data && errs.response.data.message ? errs.response.data.message : '操作失败';
        message.error(errorMsg);
        reject(errs);
      });
  });
}
